<template>
<div id="pt360" class="pt360" v-cloak>
    <!--パンくずリスト-->
    <template v-if="pt360ReqModel.firstLoginFlg == 0">
        <breadcrumb :decriptPage="$t('pt360.labels.resetPassword')" :topPageNm="'common.labels.login'"></breadcrumb>
    </template>
    <template v-else>
        <breadcrumb :decriptPage="$t('pt360.labels.firstLogin')" :topPageNm="'common.labels.login'"></breadcrumb>
    </template>
     <div>
        <!-- タイトル「パスワード再設定」 -->
        <div class="itemTitle">
            <h2 v-if="pt360ReqModel.firstLoginFlg == 0" >{{$t('pt360.labels.resetPassword')}}</h2>
            <h2 v-else>{{$t('pt360.labels.firstLogin')}}</h2>
        </div>
        
        <div class="section-inner">
            <div v-if="mapMessValid.length > 0 || listMessValid.length > 0" class="error-message">
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt360'"/>
            </div>
            <template v-if="pt360Init.errorCode == ''">
                <div class="questionInfo" v-html="pt360Init.descriptionInfo['20']"></div>
                <br>
                <table class="questionForm">
                    <!-- ご登録メールアドレス -->
                    <tr>
                        <th class="required">
                            <span id="kokyakuMail_lbl">{{$t('common.labels.registerEmailAddr')}}</span>
                        </th>
                        <td>
                            <div v-html="pt360Init.descriptionInfo['1']"></div>
                            <input-check type="text" class="mail" v-model="pt360ReqModel.kokyakuMail" id="kokyakuMail"  maxlength="80" size="35"/>
                            <div v-html="pt360Init.descriptionInfo['2']"></div>
                        </td>
                    </tr>
                    <!-- 電話番号 -->
                    <template v-if="pt360Init.dispTelFlg == 1 && pt360ReqModel.uuidKokyaku != '' && pt360ReqModel.uuidKokyaku != null && pt360ReqModel.uuidKokyaku != undefined">
                        <tr>
                            <th class="required" >
                                <span id="tel_lbl">{{$t('common.labels.phoneNumber')}}</span>
                            </th>
                            <td>
                                <div v-html="pt360Init.descriptionInfo['3']"></div>
                                <input-check v-model="pt360ReqModel.tel" id="tel" class="tel" maxlength="15" type="text"/>
                                <div v-html="pt360Init.descriptionInfo['4']"></div>
                            </td>
                        </tr>
                    </template>
                    <!-- 得意先コード -->
                    <template v-else-if="pt360ReqModel.uuid != '' && pt360ReqModel.uuid != null && pt360ReqModel.uuid != undefined">
                        <tr>
                            <th>
                                <span id="kokyakuCd_lbl">{{$t('common.labels.customerNum')}}</span>
                            </th>
                            <td>
                                <input-check v-model="pt360ReqModel.kokyakuCd" id="kokyakuCd" class="code" maxlength="15" type="text"/>
                            </td>
                        </tr>
                    </template>
                    <!-- 新しいパスワード -->
                    <tr>
                        <th class="required">
                            <span id="password_lbl">{{$t('pt360.labels.newPassword[0]')}}</span>
                        </th>
                        <td>
                            <div v-html="pt360Init.descriptionInfo['5']"></div>
                            <input-check v-model="pt360ReqModel.password" id="password" maxlength="16" type="password" autocomplete="off"/>
                            <div v-html="pt360Init.descriptionInfo['6']"></div>
                        </td>
                    </tr>
                    <!-- 新しいパスワード（確認） -->
                    <tr>
                        <th class="required">
                            <span id="confirmPassword_lbl">{{$t('pt360.labels.newPassword[0]')}} {{$t('pt360.labels.newPassword[1]')}}</span>
                        </th>
                        <td>
                            <div v-html="pt360Init.descriptionInfo['7']"></div>
                            <input-check v-model="pt360ReqModel.confirmPassword" id="confirmPassword" maxlength="16" type="password" autocomplete="off"/>
                            <div v-html="pt360Init.descriptionInfo['8']"></div>
                        </td>
                    </tr>
                </table>
                <!--初回ログインの場合規約表示-->
                <table class="agreement" v-if="pt360ReqModel.firstLoginFlg == 1">
                    <tr>
                        <!-- 会員規約* -->
                        <td class="memberAgreement">{{$t('pt400.labels.membership')}}</td>
                    </tr>
                    <tr>
                        <td>
                            <!--項目説明マスタ[40]-->
                            <div class="agreement_desc" v-html="pt360Init.descriptionInfo['40']">
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <input type="radio" id="AgreeFlag1" name="AgreeFlag" value="1" v-model="pt360ReqModel.agreeFlag">
                            <label for="AgreeFlag1">{{$t('pt400.labels.agreeItems')}}</label>
                            &nbsp;&nbsp;
                            <!-- 規約に同意しない -->
                            <input type="radio" id="AgreeFlag0" name="AgreeFlag" value="0" v-model="pt360ReqModel.agreeFlag">
                            <label for="AgreeFlag0">{{$t('pt400.labels.dontAgree')}}</label>
                        </td>
                    </tr>
                </table>
                
                <div class="questionBtn">
                    <a class="btnSubmit" v-if="pt360ReqModel.firstLoginFlg == 0" @click="isShowAlert = true">{{$t('pt360.buttons.change')}}</a>
                    <a class="btnSubmit" v-if="pt360ReqModel.firstLoginFlg == 1" @click="confirmDoInsert()">{{$t('pt360.buttons.change')}}</a>
                </div>
            </template>
            <dl v-else-if="pt360Init.errorCode == 3">
                <!-- パスワードが変更されました。 -->
                <div class="error-message">
                    <p>{{$t('pt360.labels.msgChangedPassword')}}</p>
                </div>
                <div class="questionBtn">
                    <!-- TOP画面へ -->
                    <a class="btnSubmit" @click="pt350PageBack(0)">{{$t('pt360.buttons.gotoTop')}}</a>
                </div>
            </dl>
        </div>
     </div>
    <!-- パスワードを変更します。
    よろしいですか？ -->
    <alert-confirm
        v-if="isShowAlert"
        v-bind:msgConfirm="$t('pt360.labels.msgAlertChangePassword')"
        :okAction="doSubmit"
        size="md"/>
    <!--アラート表示-->
    <alert-confirm
        v-if="isModalShow"
        :msgConfirm="msgConfirm"
        :okAction="doAction"
        :isButtonCancel="isButtonCancel"/>
</div>
</template>
<script>
/* eslint-disable */
//import $ from 'jquery';
import common from 'assets/js/common';
import axios from "assets/js/request";
import Message from 'components/MessageEcSite';
import InputCheck from 'components/InputCheck';
import SiteConstants from 'assets/const/SiteConstants.json';
import AlertConfirm from 'components/AlertConfirm';
import EventBus from "assets/js/eventBus";
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
    name: "PT360SecretQuestion",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    components: {
        InputCheck,
        Message,
        AlertConfirm,
        Breadcrumb
    },
    data() {
        return {
            REQUEST_NOT_FOUND_ERR: '001',
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],
            pt360ReqModel:{
                kokyakuMail: null,
                kokyakuCd: null,
                tel: null,
                password: null,
                confirmPassword: null,
                uuidKokyaku: null,
                uuid: null,
                firstLoginFlg: 0,
                agreeFlag:0
            },

            pt360Init:{
                errorCode: null,
                descriptionInfo:{},
                dispTelFlg:1
            },
            isShowAlert: false,
            isModalShow: false,
            isButtonCancel: true,
            msgConfirm: '',
            actionFlg : 0,
            SiteConstants: SiteConstants,
            site: ""
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            _this.pt360Init = _this.ptInitData;
            // エラーになった場合　パスワード忘れた方へページへ
            if (_this.pt360Init.errorCode == _this.REQUEST_NOT_FOUND_ERR) {
                _this.$router.push({name: _this.SiteConstants.PG010MAIN, query: {pageNo: 14},params:{messageFlg: 1}});
            }
            // 会員規約のセット
            var splInfo = _this.pt360Init.descriptionInfo['40'];
            if (splInfo != null && splInfo.length > 0) {
                splInfo = splInfo.split('\n');
                var des40 = '';
                for(var i = 0; i < splInfo.length; i++){
                    des40 = des40.concat(splInfo[i] + '<br>');
                }
                _this.pt360Init.descriptionInfo['40'] = des40;
            }
        }else{
            // eslint-disable-next-line
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT360 + _this.$UrlConstants.DO_INIT, _this.pt360ReqModel).then(function(response) {
                _this.pt360Init = response.data;
                // エラーになった場合　パスワード忘れた方へページへ
                if (_this.pt360Init.errorCode == _this.REQUEST_NOT_FOUND_ERR) {
                    _this.$router.push({name: _this.SiteConstants.PG010MAIN, query: {pageNo: 14},params:{messageFlg: 1}});
                }
                // 会員規約のセット
                var splInfo = _this.pt360Init.descriptionInfo['40'];
                if (splInfo != null && splInfo.length > 0) {
                    splInfo = splInfo.split('\n');
                    var des40 = '';
                    for(var i = 0; i < splInfo.length; i++){
                        des40 = des40.concat(splInfo[i] + '<br>');
                    }
                    _this.pt360Init.descriptionInfo['40'] = des40;
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }

        EventBus.$on('closed', () => {
            _this.isShowAlert = false;
            _this.isModalShow = false;
        });
    },
    methods: {
        /**
         * update new password
         * @param
         * @returns
         */
        doSubmit: function(){
            var _this = this;
            _this.isShowAlert = false;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr,'pt360');
            _this.$emit("event-loading", true);
            // Call API send mail update password
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT360 + _this.$UrlConstants.DO_UPDATE, _this.pt360ReqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.pt360Init.errorCode = 3;
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error,'pt360');
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * Goto top page pg010
        */
        pt350PageBack: function(loginFlg){
            if (loginFlg == 1) {
                this.$router.push({name: this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
            } else {
                this.$router.push({name: this.SiteConstants.PG010MAIN, query:{pageNo:1}});
            }
        },
        /**
         * goto send email (pt350)
         */
        pt360pass: function(){
            this.$router.push({name: this.SiteConstants.PG010MAIN, query: {pageNo: 14}});
        },
        /*
        * 登録ボタン押下処理
        */
        confirmDoInsert: function(){
            // 同意ラジオボタン
            if(this.pt360ReqModel.agreeFlag != 1){
                // 規約に同意いただける場合のみ会員登録することができます。
                this.msgConfirm = this.$i18n.t('pt400.labels.messg1');
                this.isModalShow = true;
                this.isButtonCancel = false;
                this.actionFlg = -1;
                return;
            }
            this.msgConfirm = this.$i18n.t('pt360.labels.msgAlertChangePassword');
            this.isModalShow = true;
            this.isButtonCancel = true;
            this.actionFlg = 1;
        },
        /*
        *  POPUP表示処理 actionFlg
        * 1: 同意
        */
        doAction: function(){
            var _this = this;
            switch (_this.actionFlg) {
                case 1:
                    _this.doSubmit();
                    break;
                default:
                    break;
            }
            // Hide alert confirm
            _this.isModalShow = false;
            _this.actionFlg = 0;
            _this.isButtonCancel = true;
        },
    },
    created(){
        var _this = this;
        // Get data from query
        var queryData = _this.$route.query;
        if(Object.keys(queryData).length > 0){
            if(queryData.k != undefined && queryData.k != '' && queryData.k != null){
                _this.pt360ReqModel.uuidKokyaku = queryData.k;
            }
            if(queryData.id != undefined && queryData.id != '' && queryData.id != null){
                _this.pt360ReqModel.uuid  = queryData.id;
            }
            if (queryData.firstLoginFlg != undefined && queryData.firstLoginFlg != '' && queryData.firstLoginFlg != null) {
                _this.pt360ReqModel.firstLoginFlg = queryData.firstLoginFlg;
            }
        }
    }
}
</script>
